<template>
    <div ref="BookPage" class="all">
      <div class="top">
        <img src="static/images/img_1_1.png" alt="">
      </div>
      <div class="center">
        <img src="static/images/img_1_2.png" alt="" class="bg_2_img">
        <img src="static/images/img_2.png" alt="" class="png2">
        <img src="static/images/img_7.png" alt="" class="png3">
        <img src="static/images/img_3.png" alt="" class="png4">
      </div>
      <div class="bottom">
        <img src="static/images/img_1_3.png" alt="" class="bg_3_img">
        <div class="bottom_title">精品课程推荐</div>
        <img src="static/images/img_4.png" alt="" class="bottom_img_1" @click="go_one">
        <img src="static/images/img_5.png" alt="" class="bottom_img_2" @click="go_two">
        <img src="static/images/img_6.png" alt="" class="bottom_img_3" @click="go_three">
      </div>
    </div>
</template>

<script>
    export default {
        name: "PackageHandBook",
      data(){
          return{
            clientHeight: '',
          }
      },
      methods: {
        // changeFixed(clientHeight) {
        //   this.$refs.BookPage.style.height = clientHeight + 'px';
        // },
        go_one(){
          window.location.href = 'kekeshi://app.kekeshi.com/course/package?uuid=645a9fc2-13d5-4d59-bb10-fd0ffbb098e7';
        },
        go_two(){
          window.location.href = 'kekeshi://app.kekeshi.com/course/package?uuid=9af6f13d-8b1c-4050-a5cc-27d90b0869ca';
        },
        go_three(){
          window.location.href = 'kekeshi://app.kekeshi.com/course/package?uuid=7be3370d-2f66-44ec-b9a0-5990eb76efce';
        },
      },
      mounted() {
        // // 获取浏览器可视区域高度
        // this.clientHeight =   `${document.documentElement.clientHeight}`;          //document.body.clientWidth;
        // //console.log(self.clientHeight);
        // window.onresize = function temp() {
        //   this.clientHeight = `${document.documentElement.clientHeight}`;
        // };
      },
      // watch: {
      //   // 如果 `clientHeight` 发生改变，这个函数就会运行
      //   clientHeight: function () {
      //     this.changeFixed(this.clientHeight)
      //   }
      // },
    }
</script>

<style scoped>
  .all{
    width: 100%;
    height: auto;
    overflow-x: hidden;
  }
  img{
    display: block;
  }
  .top {
    width: 100%;
    position: relative;
  }
  .top img{
    width: 100%;
  }
  .center{
    width: 100%;
    position: relative;
    height: auto;
  }
  .bg_2_img,.bg_3_img{
    width: 100%;
    top:0;
    left:0;
  }
  .png2{
    position: absolute;
    z-index: 10;
    top:-13px;
    width: 355px;
    left:calc((100% - 355px) / 2);
  }
  @keyframes mymove
  {
    0%{
      transform: scale(1);  /*开始为原始大小*/
    }
    25%{
      transform: scale(0.95); /*放大1.1倍*/
    }
    50%{
      transform: scale(1);
    }
    75%{
      transform: scale(0.95);
    }

  }
  @keyframes mymove2
  {
    0%{
      transform: scale(1);  /*开始为原始大小*/
    }
    25%{
      transform: scale(0.95); /*放大1.1倍*/
    }
    50%{
      transform: scale(1);
    }
    75%{
      transform: scale(0.95);
    }

  }
  .png3
  {
    position: absolute;
    top: 127px;
    left: calc((100% - 30px) / 2);
    width: 30px;
  }
  .png4
  {
    width: 355px;
    position: absolute;
    top: 167px;
    left:calc((100% - 355px) / 2);
  }
  .bottom_box{
    position: absolute;
    bottom: 0;
    width: 100%;
  }
  .bottom_box img{
    width: 100%;
  }
  .bottom{
    position: relative;
  }
  .bottom_img_1{
    width: 355px;
    position: absolute;
    left:calc((100% - 355px) /2);
    top:70px;
    animation:mymove2 5s infinite;
    -webkit-animation:mymove 3s infinite; /*Safari and Chrome*/
    animation-direction:alternate;/*轮流反向播放动画。*/
    animation-timing-function: ease-in-out; /*动画的速度曲线*/
    /* Safari 和 Chrome */
    -webkit-animation-direction:alternate;/*轮流反向播放动画。*/
    -webkit-animation-timing-function: ease-in-out; /*动画的速度曲线*/
  }
  .bottom_img_2{
    width: 355px;
    position: absolute;
    left:calc((100% - 355px) /2);
    top:214px;
    animation:mymove2 5s infinite;
    -webkit-animation:mymove 3s infinite; /*Safari and Chrome*/
    animation-direction:alternate;/*轮流反向播放动画。*/
    animation-timing-function: ease-in-out; /*动画的速度曲线*/
    /* Safari 和 Chrome */
    -webkit-animation-direction:alternate;/*轮流反向播放动画。*/
    -webkit-animation-timing-function: ease-in-out; /*动画的速度曲线*/
  }
  .bottom_img_3{
    width: 355px;
    position: absolute;
    left:calc((100% - 355px) /2);
    top:358px;
    animation:mymove2 5s infinite;
    -webkit-animation:mymove 3s infinite; /*Safari and Chrome*/
    animation-direction:alternate;/*轮流反向播放动画。*/
    animation-timing-function: ease-in-out; /*动画的速度曲线*/
    /* Safari 和 Chrome */
    -webkit-animation-direction:alternate;/*轮流反向播放动画。*/
    -webkit-animation-timing-function: ease-in-out; /*动画的速度曲线*/
  }
  .bottom_title
  {
    position: absolute;
    top: 20px;
    font-size: 22px;
    left:10px;
    color:white;
    z-index: 10;
  }
</style>



// WEBPACK FOOTER //
// src/components/PackageHandBook.vue